module.exports = __webpack_public_path__ + "img/591.4724b372.jpg";